import { render, staticRenderFns } from "./UANWidget.vue?vue&type=template&id=6c9a31d1&scoped=true"
import script from "./UANWidget.vue?vue&type=script&lang=js"
export * from "./UANWidget.vue?vue&type=script&lang=js"
import style0 from "./UANWidget.vue?vue&type=style&index=0&id=6c9a31d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9a31d1",
  null
  
)

export default component.exports